export default __webpack_public_path__ + "static/door2-5238444355039543f4ec4c808d6d6456.jpg";